const parseDateTimeLocal = (value) => {
	if (typeof value !== 'string' || !value.includes('T')) return null
	const [datePart, timePart] = value.split('T')
	if (!datePart || !timePart) return null
	const [year, month, day] = datePart.split('-').map(Number)
	const [hour, minute] = timePart.split(':').map(Number)
	if (![year, month, day, hour, minute].every((n) => Number.isFinite(n))) {
		return null
	}
	return { year, month, day, hour, minute }
}

const getOffsetMsForTimezone = (date, timeZone) => {
	const formatter = new Intl.DateTimeFormat('en-US', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hourCycle: 'h23',
	})
	const parts = formatter
		.formatToParts(date)
		.reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {})
	const asUtc = Date.UTC(
		Number(parts.year),
		Number(parts.month) - 1,
		Number(parts.day),
		Number(parts.hour),
		Number(parts.minute),
		Number(parts.second),
	)
	return asUtc - date.getTime()
}

export const toUtcIsoInTimezone = (localValue, timezone) => {
	const parsed = parseDateTimeLocal(localValue)
	if (!parsed) return null
	const utcGuess = new Date(
		Date.UTC(
			parsed.year,
			parsed.month - 1,
			parsed.day,
			parsed.hour,
			parsed.minute,
			0,
		),
	)
	const offsetA = getOffsetMsForTimezone(utcGuess, timezone)
	let result = new Date(utcGuess.getTime() - offsetA)
	const offsetB = getOffsetMsForTimezone(result, timezone)
	if (offsetA !== offsetB) {
		result = new Date(utcGuess.getTime() - offsetB)
	}
	return result.toISOString()
}

export const getBlastScheduleError = (scheduledAt) => {
	if (!scheduledAt) return 'Please provide a valid scheduled send time.'
	if (new Date(scheduledAt).getTime() <= Date.now() + 5 * 60 * 1000) {
		return 'Choose a time more than 5 minutes in the future, or use Send Now.'
	}
	return ''
}
